import React from 'react'

const Donate = () => (
  <div className="row justify-content-center">
    <div className="col-12 col-md-10 col-lg-8 col-xl-6 mb-4">
      <h1>Donate</h1>
      <p>Support this website: <a href="https://www.buymeacoffee.com/charitykirk">Buy Me A Coffee</a></p>
      <h2>Support Native Plant Groups</h2>
      <ul>
        <li><a href="https://ncwildflower.org/" target="_blank">North Carolina Native Plant Society</a></li>
        <li><a href="https://ncbg.unc.edu/" target="_blank">The North Carolina Botanical Garden</a></li>
        <li><a href="https://www.inaturalist.org/donate" target="_blank">iNaturalist</a></li>
        <li><a href="https://www.natureserve.org/civicrm/contribute/transact?reset=1&id=1" target="_blank">NatureServe</a></li>
      </ul>
    </div>
  </div>
);

export default Donate;
